// extracted by mini-css-extract-plugin
module.exports = {"container":"error-modal_container__WsayC","title":"error-modal_title__vO5Lu"};